import React, {
  Component
}                     from 'react';
import PropTypes      from 'prop-types';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal,
  ButtonGroup,
  DropdownButton,
  MenuItem
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
//import Alert          from '../../../components/alert/Alert';
import { createBrowserHistory } from 'history';
import {
  NewBreadcrumb as BreadcrumbComponent
}                        from '../../../../components';

// include action file for add merchant
import '../../../../style/subAdmin/SubAdmin.scss';
import { Notification } from '../../../../components/notifications';
import isEmpty from 'lodash.isempty';
import { getDealList, sendTestMail } from '../../../../redux/actions/emailManagerActions';
import {renderAlert, clearAlert} from '../../../../redux/actions/alertsActions';
import { getCities } from "../../../../redux/actions/countryCityActions";

import moment from 'moment';
import loader from '../../../../style/loader/loader.scss'; 
import '../../../../style/react-datetimepicker.scss';
import Dialog from 'react-bootstrap-dialog';

import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-paginating';

const history = createBrowserHistory();

const HorizontalLine = ({ }) => (
    <hr/>
);

const propTypes = {
    emailOverview: PropTypes.func.isRequired,
};
let cityItems=[];let isLoading="false",  csvData = [];
class ChooseOffer extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props){

    super(props);
    this.state={
      path: ['Home', 'Email Manager', 'Offer Campaign'], 
      links: ["home",'email-manager/overview','email-manager/offeremail'],
      date: new Date(),
      citiesList: [],
      disabled: false,
      cityID: '',
      isLoading: 'false',
      dealList: '',
      emailType: '',
      popUpData: '',
      popUpStatus: false,
      emailPopUpData: '',
      emailPopUpStatus: false,
      email: '',
      alertMessage: '',
      show: false,
      totalRecords: 0,
      perPage: 0,
      limit:10,
      currentPage: 1,
      pageCount:0,
      scheduleOnSortIcon: "",
      dealTextSortIcon: "",
      titleSortIcon: "",
      direction: "",
    }

    this.handleChange=this.handleChange.bind(this);
    this.handleSubmit=this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.deleteCampaign = this.deleteCampaign.bind(this);

    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);

    this.emailOpenPopup = this.emailOpenPopup.bind(this);
    this.emailClosePopup = this.emailClosePopup.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleEmailExecute = this.handleEmailExecute.bind(this);
    this.notSchedule = this.notSchedule.bind(this);
  }

  handleEmailChange = (e) => {
    this.setState({email: e.target.value, emailError:""});
  }

  notSchedule = (e) => {
    this.dialog.show({
      body: 'Not Yet Scheduled',
      actions: [
        // Dialog.CancelAction(),
        Dialog.OKAction()
      ]
    })
  }

  handleEmailExecute = (e) => {
    if(this.state.email.length === 0){    
      this.setState({emailError:"red"});
      return false;
    }
    let constData = {
      id : this.state.emailPopUpData,
      email :  this.state.email,
    }

    isLoading="true";
    this.props.sendTestMail(constData);
  }

  deleteCampaign = (e) => {
    let id = e.target.attributes.getNamedItem('data-key').value;
    isLoading = "true";
    this.props.deleteEmail(id);
  }

  emailOpenPopup = (e) => {

    let data = e.target.attributes.getNamedItem('data-key').value;
    this.setState({
      emailPopUpData: data,
      emailPopUpStatus: true,
    });
  }

  emailClosePopup = (e) => {
    this.setState({
      emailPopUpData: '',
      emailPopUpStatus: false,
      email: '',
    })
  }

  openPopup = (e) => {
    let data = (e.target.attributes.getNamedItem('data-key').value) - 1;
    let dealList = this.state.dealList;
    this.setState({
      popUpData: (dealList[data].customEmailContent) ? dealList[data].customEmailContent : 'Not Scheduled.',
      popUpStatus: true,
    })
  }

  closePopup = (e) => {
    this.setState({
      popUpData: '',
      popUpStatus: false,
    })
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getDealList({ orderBy: orderBy, direction: direction, limit: this.state.limit, page:1, cityID: this.state.cityID, emailType: 'offerContest' });
  };

  handleChange(e){
    this.setState({[e.target.name]:e.target.value}) 
  }

  handlePageChange = page => {
    isLoading="true";
    this.setState({
      currentPage: page,
    });
    this.props.getDealList({page:page, cityID: this.state.cityID, emailType: 'offerContest'});
  };

  handleSubmit(e){
    e.preventDefault();
    let constData = {
      cityID: this.state.cityID,
      page:1,
      emailType: 'offerContest'
    }
    this.props.getDealList(constData);
  }
  componentWillMount(){
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData && siteData.default_city){
      this.setState({cityID: siteData.default_city});
    }
  }
  componentDidMount(){
    this.props.clearAlert ();
    this.handleDismiss();
    this.props.getCities();
    this.handlePageChange();
  }

  componentWillReceiveProps(nextProps){   

    this.setState({ sending: nextProps.sending });  
    if(this.props.error !== nextProps.error){
      if(nextProps.error){
        this.props.clearAlert ();
        this.handleShow();
        this.props.renderAlert('warning',nextProps.error);
        isLoading="false";
      }
    } 

    if (this.props.activecities !== nextProps.activecities && nextProps.activecities) {
      this.setState({ citiesList: nextProps.activecities });
    }

    if(this.props.testMailStatus !== nextProps.testMailStatus){
      if(nextProps.testMailStatus){
        this.props.clearAlert ();
        this.handleShow();
        this.props.renderAlert('success', nextProps.testMailStatus.message);
        this.emailClosePopup();
        isLoading="false";
        window.scrollTo(0, 0);
      }
    }

    if(this.props.deleteStatus !== nextProps.deleteStatus){
      if(nextProps.deleteStatus){
        this.props.clearAlert ();
        this.handleShow();
        this.props.renderAlert('success', nextProps.deleteStatus.message);
        isLoading="false";
        window.scrollTo(0, 0);
      }
    }

    if(this.props.dealList !== nextProps.dealList){
      if(nextProps.dealList){
        isLoading="false";
        const setPageCount = nextProps.dealList.data.total / nextProps.dealList.data.per_page;
        this.setState({dealList: nextProps.dealList.data.data, totalRecords:nextProps.dealList.data.total, perPage:nextProps.dealList.data.per_page, pageCount:5})
      }
    }

    if(nextProps.message){
      this.handleShow();
      this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
    }

    if(this.props.deleteStatus !== nextProps.deleteStatus){
      if(nextProps.deleteStatus){
        this.handlePageChange();
      }
    }
     
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.dealList === nextState.dealList && nextState.activecities === this.state.citiesList) {
      return false
    }
    return true
  }

  render() {
    const { currentPage,totalRecords,perPage,pageCount } = this.state
    return (
      <div className="col-lg-12 add-sub-admin">
        <Dialog ref={(el) => { this.dialog = el }} />
        {(isLoading =='true') ? 
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }
       
        <div className="row">
          <div className="col-xs-12">
             <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
        <div className="panel">
          <header className="panel-heading">Offer Campaign</header>
          <div className="panel-body">
            <Row>
              <Col md={3} xs={12}>
                <FormGroup controlId="cityFilter">
                  <ControlLabel>Filter By City</ControlLabel>
                  <FormControl componentClass="select" onChange={this.handleChange} name="cityID" value={this.state.cityID}>
                    <option value="">Select City</option>
                    {this.state.citiesList.map((data, index) => 
                      <option key={index} value={data.cityID}>{data.title}</option>
                      )}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3} xs={12}>
                <ControlLabel style={{'marginTop':'10%'}}>&nbsp;</ControlLabel>
                <Button bsStyle="info" type="submit" id="saveButton" disabled={this.state.disabled}>Submit</Button>
              </Col>
            </Row>
          </div>
        </div> 
        </form>
        {/**end contract information **/}
        <div className="row">
          <div className="col-xs-12">
            {this.state.show && this.state.alertMessage !=='' &&        
              <div className="col-lg-12">
                <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
              </Alert>
              </div>
            }
          </div>
        </div>
        <div className="panel">
          <div className="panel-body">
          <table className="table table-hover table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th onClick={this.handleSort("dealText")}>
                  Offer <span
                    className={this.state.dealTextSortIcon}
                    aria-hidden="true"
                  />
                </th>
                <th>Merchant Name</th>
                <th>Offer Status</th>
                <th onClick={this.handleSort("scheduleOn")}>
                  Scheduled <span
                    className={this.state.scheduleOnSortIcon}
                    aria-hidden="true"
                  />
                </th>
                <th onClick={this.handleSort("title")}>
                  City <span
                    className={this.state.titleSortIcon}
                    aria-hidden="true"
                  />
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
                {(!isEmpty(this.state.dealList)) ? 
                  this.state.dealList.map((data, index) => 
                    <tr key={index}>
                      <td>{++index}</td>
                      <td>{ReactHtmlParser(data.dealText)}</td>
                      <td>{data.merchantName}</td>
                      <td>{data.deal_status}</td>
                      <td className={(data.emailManagerID  && data.scheduleOn) ? 'text-success text-center' : 'text-danger text-center'}>{(data.emailManagerID && data.scheduleOn) ? `Scheduled On : ${moment(data.scheduleOn).format("YYYY-MM-DD HH:mm")}` : 'Not Yet Scheduled'}</td>
                      <td>{data.title}</td>
                      <td>
                        <ButtonGroup>
                          <DropdownButton title="Action" id="bg-nested-dropdown">
                            {(data.emailManagerID) ? 
                            <MenuItem eventKey={Math.random()} data-key={data.emailManagerID} onClick={this.emailOpenPopup}><i className="glyphicon glyphicon-send"></i> Test Email</MenuItem>
                            :
                            <MenuItem eventKey={Math.random()} onClick={this.notSchedule}><i className="glyphicon glyphicon-send"></i> Test Email</MenuItem>
                            }
                            {/*(data.emailManagerID && data.scheduleOn) ? 
                            <MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/email-manager/create-offer-email/${data.dealID}/${data.emailManagerID}`)}><i className="glyphicon glyphicon-pencil"></i> New Campaign</MenuItem>
                            :
                            <MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/email-manager/create-offer-email/${data.dealID}`)}><i className="glyphicon glyphicon-pencil"></i> New Campaign</MenuItem>
                            */}
                            <MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/email-manager/create-offer-email/${data.dealID}`)}><i className="glyphicon glyphicon-pencil"></i> New Campaign</MenuItem>
                            {(data.emailManagerID && data.scheduleOn) ? 
                            <MenuItem eventKey={Math.random()} data-key={index} onClick={this.openPopup}><i className="glyphicon glyphicon-eye-open"></i> Preview</MenuItem>
                            :
                            <MenuItem eventKey={Math.random()} data-key={index} onClick={this.notSchedule}><i className="glyphicon glyphicon-eye-open"></i> Preview</MenuItem>
                            }
                          </DropdownButton>
                      </ButtonGroup>
                      </td>
                    </tr>
                  )
                :
                <tr><td colSpan="6" className="text-center">Data Not Found</td></tr>
                }
            </tbody>
          </table>
          <div className="text-center">
                <Pagination
                  total={totalRecords}
                  limit={perPage}
                  pageCount={5}
                  currentPage={currentPage}
                >
                  {({
                    pages,
                    currentPage,
                    hasNextPage,
                    hasPreviousPage,
                    previousPage,
                    nextPage,
                    totalPages,
                    getPageItemProps
                  }) => (
                    <div className="pagination">
                      <button
                        {...getPageItemProps({
                          pageValue: 1,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        first
                      </button>

                      {hasPreviousPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: previousPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'<'}
                        </button>
                      )}

                      {pages.map(page => {
                        let activePage = null;
                        if (currentPage === page) {
                          activePage = { backgroundColor: '#ccc', color: '#666' };
                        }
                        return (
                          <button
                            key={page}
                            style={activePage}
                            {...getPageItemProps({
                              pageValue: page,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {page}
                          </button>
                        );
                      })}

                      {hasNextPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: nextPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'>'}
                        </button>
                      )}

                      <button
                        {...getPageItemProps({
                          pageValue: totalPages,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        last
                      </button>
                    </div>
                  )}
                </Pagination>
                </div>
          </div>
        </div>


        <Modal show={this.state.popUpStatus} onHide={this.closePopup}>
          <Modal.Header closeButton>
            <Modal.Title>Email Template Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {ReactHtmlParser(this.state.popUpData)}
          </Modal.Body>
          <Modal.Footer>
           {/* <Button bsStyle="success" onClick={this.handleExecute.bind(this)}>Execute</Button>*/}
            <Button bsStyle="danger" onClick={this.closePopup}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.emailPopUpStatus} onHide={this.emailClosePopup}>
          <Modal.Header closeButton>
            <Modal.Title>Send Test Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <FormGroup>
                  <ControlLabel>Enter an email address below to send a test email. Useful if you want to preview what the email will look like in your customers inbox.</ControlLabel>
                  <FormControl
                    type="email"
                    value={this.state.email}
                    placeholder="Enter Email"
                    onChange={this.handleEmailChange}
                    style={{borderColor:this.state.emailError}}
                  />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleEmailExecute}>Send Mail</Button>
            <Button bsStyle="danger" onClick={this.emailClosePopup}>Close</Button>
          </Modal.Footer>
        </Modal>
        
       
       {/*<Row className="BtnRow">
                 <Col md={12} xs={12}>
                   <Button bsStyle="info" type="submit" id="saveButton" disabled={this.state.disabled}>Save</Button>
                   <Button bsStyle="default" onClick={() => this.context.router.history.push(`/contractList`)}>Cancel</Button>
                 </Col>
               </Row>*/}
       
      </div>
    );
  }
}
 
 

const mapStateToProps = (state,ownProps) => {
    return {
      activecities: state.countryCityReducers.activecities,
      sending:  state.emailManagerReducer.sending,
      error: state.emailManagerReducer.error,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
      dealList:  state.emailManagerReducer.dealList,
      testMailStatus: state.emailManagerReducer.testMailStatus,
    };
};

export default compose(
  withRouter, 
  connect(mapStateToProps, {renderAlert, clearAlert, getDealList, sendTestMail, getCities})
)(ChooseOffer);



// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/offer/ChooseOffer.js